import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { LOGO_URL, BRAND, NAV_LINKS } from "../lib/constants";
import ThemeToggle from "./ThemeToggle";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [location.pathname]);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "backdrop-blur-xl bg-black/70 border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo-link" className="flex items-center gap-0 group">
          <img
            src={LOGO_URL}
            alt="JustZeta logo"
            className="h-10 w-10 object-contain"
            loading="eager"
          />
          <span className="font-serif-display text-2xl tracking-tight text-white">
            {BRAND.name}
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-[13px] uppercase tracking-[0.22em] hover-underline transition-colors ${
                  isActive ? "text-white" : "text-neutral-400 hover:text-white"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        {/* <div className="hidden md:flex items-center gap-4">
          <Link
            to="/contact"
            data-testid="nav-cta-getstarted"
            className="bg-[#e60000] hover:bg-[#ff1a1a] text-white px-6 py-3 text-[12px] uppercase tracking-[0.22em] transition-colors"
          >
            Get Started
          </Link>
        </div> */}
        <div className="hidden md:flex items-center gap-4">
  <ThemeToggle />
  <Link
    to="/contact"
    data-testid="nav-cta-getstarted"
    className="bg-[#e60000] hover:bg-[#ff1a1a] text-white px-6 py-3 text-[12px] uppercase tracking-[0.22em] transition-colors"
  >
    Get Started
  </Link>
</div>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
          className="md:hidden text-white p-2"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="nav-mobile-panel"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="md:hidden bg-black/95 border-t border-white/10 backdrop-blur-xl"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {NAV_LINKS.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  end={l.to === "/"}
                  data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                  className={({ isActive }) =>
                    `text-lg font-serif-display ${isActive ? "text-white" : "text-neutral-400"}`
                  }
                >
                  {l.label}
                </NavLink>
              ))}
              <Link
                to="/contact"
                data-testid="nav-mobile-cta"
                className="mt-3 bg-[#e60000] text-white px-5 py-3 text-[12px] uppercase tracking-[0.22em] text-center"
              >
                Get Started
              </Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Navbar;
